import * as React from 'react'

import { observer } from 'mobx-react'
import { classList } from 'react-classlist-helper'

import { ProjectDetailsTabs } from '~/client/src/desktop/views/ProjectSetUp/ProjectSetUpPage.store'

import ProjectSettingsStore from '../ProjectSettings.store'

interface IProps {
  store: ProjectSettingsStore
}

const ProjectHeaderBar: React.FC<IProps> = observer(({ store }) => {
  const { isTabDisabled, activeTab, setActiveTab } = store

  return (
    <div className="row project-details-tabs-header mb10">
      {Object.values(ProjectDetailsTabs).map(tab => {
        const isActive = activeTab === tab
        const isDisabled = isTabDisabled(tab)
        return (
          <div
            onClick={() => setActiveTab(tab)}
            key={tab}
            className={classList({
              'project-details-tab text large row x-center y-center no-white-space-wrap': true,
              active: isActive,
              disabled: isDisabled,
            })}
          >
            {tab}
          </div>
        )
      })}
    </div>
  )
})

export default ProjectHeaderBar
